import * as React from "react";
const SvgFiRrCauldron = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-cauldron_svg__a)">
      <path
        fill="#062147"
        d="M22.107 22.006c-.231-.028-.976-.185-1.101-1.016C22.868 19.429 24 17.382 24 15.144c0-3.012-1.558-5.616-2.724-7.143h.725a1.001 1.001 0 0 0 0-2.001l-20 .009a1 1 0 0 0 0 2h.718C1.553 9.537.001 12.136.001 15.143c0 2.239 1.132 4.285 2.994 5.846-.126.829-.865.987-1.099 1.016a1 1 0 0 0 .201 1.991c.736-.071 2.032-.549 2.617-1.821C6.736 23.319 9.263 24 12.001 24s5.266-.681 7.287-1.825c.585 1.272 1.882 1.75 2.617 1.821q.048.004.096.004c.503 0 .93-.381.986-.892a1.006 1.006 0 0 0-.88-1.102M2 15.143c0-3.826 3.289-7.068 3.358-7.135l13.277-.006.005.005c.034.032 3.36 3.289 3.36 7.137 0 3.781-4.486 6.857-10 6.857S2 18.925 2 15.144zM7 1.5a1.5 1.5 0 1 1 3.001.001A1.5 1.5 0 0 1 7 1.5m7 1a1.5 1.5 0 1 1 3.001.001A1.5 1.5 0 0 1 14 2.5"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-cauldron_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCauldron;
